import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Users, BadgeEuro } from "lucide-react";
import { useSite } from "@/i18n/SiteContext";
import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/lib/images";

export default function AboutPage() {
  const { t } = useSite();
  return (
    <div data-testid="about-page">
      <section className="relative h-[70vh] min-h-[480px] flex items-end overflow-hidden">
        <img src={IMAGES.about} alt="Naples, Spaccanapoli" className="absolute inset-0 w-full h-full object-cover" />
        <div className="hero-overlay absolute inset-0" />
        <Reveal className="relative max-w-6xl mx-auto w-full px-6 pb-16">
          <p className="text-xs font-medium tracking-super-wide text-sand-brand uppercase mb-4">{t("about.eyebrow")}</p>
          <h1 className="font-serif text-4xl md:text-6xl text-ivory font-normal leading-tight max-w-3xl">{t("about.title")}</h1>
        </Reveal>
      </section>
      <section className="section-padding">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="brand-line mb-8" />
            <p className="font-serif text-2xl md:text-3xl text-ocean leading-snug">{t("about.p1")}</p>
            <p className="mt-8 text-lg text-ocean/70 leading-relaxed">{t("about.p2")}</p>
          </Reveal>
        </div>
      </section>
      <section className="bg-ocean section-padding relative noise">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10">
          {[{ i: MapPin, k: 1 }, { i: Users, k: 2 }, { i: BadgeEuro, k: 3 }].map(({ i: Icon, k }, idx) => (
            <Reveal key={k} delay={idx * 0.1} className="text-center">
              <div className="w-14 h-14 mx-auto rounded-full bg-ivory/5 border border-ivory/10 flex items-center justify-center mb-5"><Icon size={26} className="text-sea" /></div>
              <h3 className="font-serif text-xl text-ivory mb-3">{t(`about.v${k}t`)}</h3>
              <p className="text-sm text-ivory/65 leading-relaxed">{t(`about.v${k}d`)}</p>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="section-padding text-center">
        <Link to="/tours" data-testid="about-tours-cta" className="inline-block px-10 py-4 bg-ocean text-ivory text-sm font-medium tracking-wider uppercase hover:bg-ocean-700 btn-lift">{t("about.cta")}</Link>
      </section>
    </div>
  );
}
